// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"dab128d1","526":"28ee1787","787":"5c0b2d12"}[chunkId] + ".chunk.js";
};